import { render, staticRenderFns } from "./head-2.vue?vue&type=template&id=d7497b48&scoped=true&lang=pug&"
import script from "./head-2.vue?vue&type=script&lang=js&"
export * from "./head-2.vue?vue&type=script&lang=js&"
import style0 from "./head-2.vue?vue&type=style&index=0&id=d7497b48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7497b48",
  null
  
)

export default component.exports